<template>
    <div :style="cssProps" style="position: relative;">
        <span
          v-if="title"
          class="font-secundaria campo-cadu"
          :class="disabled ? 'disabled-text': ''"
          :style="{ color: colorText }"
        >
            {{title}}
        </span>
        <div
          class="input-container"
        >
          <icon
            v-if="iconData"
            @click.native="$emit('click')"
            :style="disabled ? {} : { 'cursor': clickIcon ? 'pointer' : 'text', 'color' : colorIcon ? colorIcon : ''}"
            class="icon-cadu"
            :name="iconData"
            :size="sizeIcon"

          />
          <input
              v-if="mask"
              :name="name"
              :disabled="disabled"
              :value="value"
              :class=" {
                'cadu_input--disabled': disabled,
                'cadu_input--error': disabled ? '': hasError,
                'cadu_input--success': hasSuccess
              }"
              :style=" {
                  'color': colorInput,
                  'background-color': colorBgField,
                  'text-align': textAlign,
                  'placeholdercolor': colorPlaceholder,
                  '-ms-input-placeholdercolor': colorPlaceholder,
                  '-ms-input-placeholdercolor': colorPlaceholder
                }"
              v-mask="mask"
              :type="typeInput"
              class="input-cadu"
              ref="inputCadu"
              :placeholder="placeholder"
              @input="inputEvent"
              @focus="inputEvent"
              @keypress="isNumber"
              @keypress.enter="$emit('enter')"
              spellcheck="false"
              :minlength="min"
              :maxlength="max"
          />
          <input
            v-else
            :name="name"
            :disabled="disabled"
            :value="value"
            :class=" {
              'cadu_input--disabled': disabled,
              'cadu_input--error': disabled ? '': hasError,
              'cadu_input--success': hasSuccess
            }"
            :style=" {
                'color': colorInput,
                'background-color': colorBgField,
                'text-align': textAlign,
                'placeholdercolor': colorPlaceholder,
                '-ms-input-placeholdercolor': colorPlaceholder,
                '-ms-input-placeholdercolor': colorPlaceholder
              }"
            :type="typeInput"
            class="input-cadu"
            ref="inputCadu"
            :placeholder="placeholder"
            @keypress.enter="$emit('enter')"
            @input="inputEvent"
            @focus="inputEvent"
            @keypress="isNumber"
            spellcheck="false"
            :minlength="min"
            :maxlength="max"
          />
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import props from './props'
export default {
  props,
  directives: {
    mask
  },
  data () {
    return {
      colorData: this.color,
      iconData: this.icon,
      isIcon: false,
      focused: false,
      id: -1
    }
  },
  created () {
    this.$nextTick(() => {
      if (this.valueComputed) {
        this.inputEvent()
      }
    })
  },
  methods: {
    isNumber (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (this.onlyNumber) {
        evt = (evt) || window.event
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
        } else {
          return true
        }
      } else if (this.onlyText) {
        const char = String.fromCharCode(charCode)
        if (!/[a-zA-ZzáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ. ]/.test(char)) {
          event.preventDefault()
        }
      } else if (this.onlyAlphaNum) {
        if (/[^a-zA-Z0-9 ]/gi.test(String.fromCharCode(charCode))) {
          event.preventDefault()
        }
      } else if (this.emailMask) {
        if (!/[0-9a-zA-Z . @ \- _ ]/gi.test(String.fromCharCode(charCode))) {
          event.preventDefault()
        }
      }
    },
    focusError () {
      this.colorData = this.colorError
    },
    inputEvent (evt) {
      this.focused = true
      let el = this.$refs.inputCadu

      var position = el.selectionEnd
      var digit = el.value[position - 1]
      while (position < el.value.length && el.value.charAt(position - 1) !== digit) {
        position++
      }
      if (el === document.activeElement) {
        el.setSelectionRange(position, position)
        setTimeout(function () {
          el.setSelectionRange(position, position)
        }, 0)
      }

      let value = this.upperOrLower(this.$refs.inputCadu.value)
      value = this.mask ? value.replace(/\./g, '') : value
      this.$emit('input', value)
    },
    handleClickOutside (evt) {
      if (this.focused && !this.$el.contains(evt.target)) {
        this.focused = false
        this.$refs.inputCadu.blur()
        this.$emit('blur')
      }
    },
    upperOrLower (value) {
      if (value) {
        return this.onlylowerCase ? value.toLowerCase() : this.onlyUpperCase ? value.toUpperCase() : value
      }
      return ''
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  computed: {
    hasError () {
      return !!this.errorMessage
    },
    hasSuccess () {
      return !!this.success
    },
    cssProps () {
      return {
        '--placeholder-color': this.colorPlaceholder
      }
    },
    valueComputed () {
      return this.value
    }
  },
  watch: {
    icon () {
      this.iconData = this.icon
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #9E9E9E
$corTexto: #000000
$corFundoDisabled: #e1e6eb
$corIcon: #60656C
$corCombo: #FFFFFF
$corComboHover: #DEE2E6
$corPlaceHolder: #707070
$corError: #ED1651
$break-small: 500px
$break-large: 1200px
$corTextoDisabled:#222326
$corTextoHabilitado: #54585e

.campo-cadu
  font-size: 1rem

.help-cadu
  position: absolute
  color: #616161
  top: 30px
  left: 0px
  margin-left: 2px
  margin-top: 4px
  line-height: 16px
  font-size: 1rem
  transition: opacity 0.2s
  width: 150px

.input-cadu
  outline:0
  background-color: transparent
  width: 100%
  padding: 7px 15px
  margin: 2px 0
  height: 30px
  box-sizing: border-box
  border: 1px solid $corBorda
  border-radius: 5px
  font-size: 1rem
  color:$corTextoHabilitado
  &::placeholder
    opacity: 1
    color: var(--placeholder-color)
  &::-ms-input-placeholder
    opacity: 1
    color: var(--placeholder-color)

.cadu_input--disabled
  opacity: 0.6
  cursor: not-allowed
  background-color: $corFundoDisabled
  color: $corTextoDisabled

.disabled-text
  color: $corBorda

.input-container
  position: relative
  width: 100%
  display: block

.cadu_input--error
  border-color: $corError

.cadu_input--success
  color: #00995D

.icon-cadu
  position: absolute
  right: 2px
  text-align: center
  color: $corIcon
  margin: 8px
  cursor: text
</style>
